import api from './api';

const basePath = '/api/books';

export const fetchBooks = async ({
  page = 1,
  pageSize = 10,
  searchTerm = '',
  isRented = null,
} = {}) => {
  const params = {
    pageNumber: page,
    pageSize,
  };

  if (searchTerm) params.searchTerm = searchTerm;
  if (isRented !== null) params.isRented = isRented;

  return api.get(basePath, { params });
};

export const getBook = async (id) => api.get(`${basePath}/${id}`);

export const createBook = async (payload) => api.post(basePath, payload);

export const updateBook = async (payload) => api.put(basePath, payload);

export const deleteBook = async (id) => api.delete(`${basePath}/${id}`);

export const rentBook = async (payload) => api.post(`${basePath}/rent`, payload);

export const returnBook = async (id) => api.post(`${basePath}/return/${id}`);

export const fetchRentalHistory = async ({
  page = 1,
  pageSize = 10,
  searchTerm = '',
  bookId = null,
  status = '',
  tc = '',
  mail = '',
} = {}) => {
  const params = {
    pageNumber: page,
    pageSize,
  };

  if (searchTerm) params.searchTerm = searchTerm;
  if (bookId) params.bookId = bookId;
  if (status) params.status = status;
  if (tc) params.tc = tc;
  if (mail) params.mail = mail;

  return api.get(`${basePath}/rental-history`, { params });
};

export const bulkCreateBooks = async (books) => api.post(`${basePath}/bulk`, { books });

export const getActiveRentalsByUser = async ({ tc, mail } = {}) => {
  const params = {};
  if (tc) params.tc = tc;
  if (mail) params.mail = mail;
  return api.get(`${basePath}/active-rentals`, { params });
};